document.addEventListener("DOMContentLoaded", function(event) {
  //Toggle content in oportunities page
  const teacherSelector = document.querySelector("select[name='attribute_profesor']");
  const teacherSelectorLabel = document.querySelector("tr:has(select[name='attribute_profesor']) .label");
  if(teacherSelector) {
    const modelSelector = document.querySelector("select[name='attribute_pa_modelo']");
    if(modelSelector && modelSelector.value === 'a-tu-bola') {
        teacherSelector.value = 'Rosendo';
        teacherSelectorLabel.style.display = 'none';
        teacherSelector.style.display = 'none';
    }
    modelSelector.addEventListener("change", (event) => {
      const selectedOption = event.target.value;
      if(selectedOption === 'a-tu-bola') {
        teacherSelector.value = 'Rosendo';
        teacherSelectorLabel.style.display = 'none';
        teacherSelector.style.display = 'none';
      }else {
        teacherSelectorLabel.style.display = 'block';
        teacherSelector.style.display = 'inline-block';
      }
    });
  }
    
});